<template>
    <CookieControl locale="en">
        <template #bar>
            <div>
                <div class="flex items-center">
                    <p class="text-gray-100 font-bold">We use cookies</p>
                </div>
                <div class="flex w-full justify-end">
                    <p class="!text-body-sm !text-gray-600">
                        We use cookies to enhance your experience. By clicking 'Accept,' you agree to our Cookie Policy
                        in the Privacy Policy footer.
                    </p>
                </div>
            </div>
        </template>
    </CookieControl>
</template>
<script setup lang="ts">
const { cookiesEnabled } = useCookieControl();
const cookieRef = ref();

const nuxtApp = useNuxtApp();
const loaded = ref(false);
nuxtApp.hook("page:finish", () => {
    loaded.value = true;
    nuxtApp.$setDefaultGa4Consent();
});

watch(
    () => cookiesEnabled.value,
    () => {
        cookieRef.value?.classList.add("cookie-hidden");
        if ((cookiesEnabled.value?.length ?? 0) > 1) {
            nuxtApp.$setGa4Consent("granted");
        } else {
            nuxtApp.$setGa4Consent("denied");
        }
    },
    { deep: true }
);
</script>
<style lang="scss">
.cookieControl {
    &__BarButtons :nth-child(2) {
        display: none !important;
    }
    &__ModalButtons :nth-child(3) {
        display: none !important;
    }
}
</style>
